import React, { useEffect } from "react"
import { useFormik } from "formik"
import * as Yup from "yup"
import { FormGroup, Label, Input, Row, Col } from "reactstrap"
import { Button } from "components/Button"

import { FIELDS_NAME, initialValues, validationSchema } from "./FormConfig"

const EditNoteForm = ({ note, onSave, onCancel, isLoading }) => {
   const formik = useFormik({
      initialValues,
      validationSchema,
      onSubmit: async values => {
         await onSave(note.id, {
            note: values.textAreaValue,
            resolved: values.isChecked,
         })
         onCancel()
      },
   })

   useEffect(() => {
      formik.setValues({
         [FIELDS_NAME.TEXT_AREA_VALUE]: note.note,
         [FIELDS_NAME.IS_CHECKED]: note.resolved,
      })
   }, [note])

   return (
      <form onSubmit={formik.handleSubmit} className="note-form">
         <FormGroup>
            <Label>Note</Label>
            <Input
               type="textarea"
               name={FIELDS_NAME.TEXT_AREA_VALUE}
               value={formik.values.textAreaValue}
               onChange={formik.handleChange}
               onBlur={formik.handleBlur}
               invalid={
                  formik.touched.textAreaValue && !!formik.errors.textAreaValue
               }
               style={{ resize: "none", height: "80px" }}
            />
            {formik.touched.textAreaValue && formik.errors.textAreaValue && (
               <div className="form-input-error text-danger">
                  {formik.errors.textAreaValue}
               </div>
            )}
         </FormGroup>
         <Row className="align-items-center">
            <Col sm={6} xs={12}>
               <FormGroup check inline>
                  <Input
                     type="checkbox"
                     name={FIELDS_NAME.IS_CHECKED}
                     value={formik.values.isChecked}
                     onChange={formik.handleChange}
                     onBlur={formik.handleBlur}
                  />{" "}
                  <Label check>Mark as resolved</Label>
               </FormGroup>
            </Col>

            <Col sm={6} xs={12} className="d-flex justify-content-end gap-1">
               <Button
                  title="Save"
                  type="submit"
                  color="primary"
                  isLoading={isLoading}
                  className="note-btn-primary"
               />

               <Button
                  type="button"
                  color="danger"
                  className="note-btn-secondary"
                  onClick={onCancel}
                  disabled={isLoading}
                  title="Cancel"
               />
            </Col>
         </Row>
      </form>
   )
}

export default EditNoteForm
